var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('div',{staticClass:"app-content-inner"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default",function(){return [_c('content-layout',[_c('router-view')],1)]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }